export const PATH_MAP = './data/ne_50m_admin_0_countries-2.json'
export const PATH_COUNTRIES = './data/countries.csv'

export const MAP_KEY = 'ne_50m_admin_0_countries'
export const MAP_COUNTRY_CODE = 'ADM0_A3'

export const LABELS = {
  'TABLE_LAND': 'Land',
  'TABLE_STATUS': 'Regierungsstatus',
  'TABLE_PUBLICATIONS': 'Publikationen',
  'TABLE_CONTACT': 'Ansprechpartner*in',
  'TABLE_CONTACT_LABEL': 'Kontakt',
  'TABLE_DATE': 'Stand',
  'TABLE_PUBLICATIONS_LABEL': 'Link',
  'TABLE_LOCATION': 'Büro'
}

export const NOT_AVAILABLE = '–'

export const colors = {
	notAvailable: '#efefef',
	other: '#b3b2b2',
	noChange: '#D8D8D8'
}

export const VALUES = {
	'Seniorpartner': '#e0594c',
	'Juniorpartner': '#e5807a',
	// 'Juniorpartner': '#efb8b6',
	'Opposition': '#6ea5cc'
}

export const LOCALE = {
	months: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember"
	],
	months_short: [
		"Jan",
		"Feb",
		"Mär",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez"
	]
}